<template>
  <BCol cols="12" v-if="scheduleDetails">
    <BRow class="custom-inner-table-bg-color rounded-sm py-1">
      <BCol cols="3" class="px-2 mx-auto">
        {{
          new Date(scheduleDetails.schedules.startDate).toLocaleDateString(
            "fa-IR"
          )
        }}
        -
        {{
          new Date(scheduleDetails.schedules.startDate).toLocaleTimeString(
            "fa-IR",
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          )
        }}
      </BCol>
      <BCol cols="3" class="px-2 mx-auto">
        {{
          new Date(scheduleDetails.schedules.endDate).toLocaleDateString(
            "fa-IR"
          )
        }}
        -
        {{
          new Date(scheduleDetails.schedules.endDate).toLocaleTimeString(
            "fa-IR",
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          )
        }}
      </BCol>
      <BCol cols="3" class="px-2 mx-auto">
        {{ scheduleDetails.isActive ? "بله" : "خیر" }}
      </BCol>
      <BCol cols="3" class="px-2 mx-auto">
        <template v-if="scheduleDetails.links">
          <a :href="scheduleDetails.links" target="_blank">
            <FeatherIcon size="23" icon="ExternalLinkIcon"></FeatherIcon>
          </a>
        </template>
        <template v-else> - </template>
      </BCol>
    </BRow>
  </BCol>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    scheduleDetails: {
      type: Object,
    },
  },
  components: {
    BRow,
    BCol,
    BButton,
  },
};
import { BRow, BCol, BButton } from "bootstrap-vue";
</script>
